export default __webpack_public_path__ + "static/media/line_liver.d2587be6.png";